import { ResponseMeInterface } from '@interface/UserInterface';
import { instance } from '@services/base';
import { AxiosResponse } from 'axios';

export const getUserLogout = async (): Promise<ResponseMeInterface> => {
  return instance
    .get('/logout')
    .then((res: AxiosResponse<ResponseMeInterface>) => res.data)
    .catch((err) => err);
};
